export const ASSET_PATHS = {
  healthBarBase: "/assets/healthBar/1.svg",
  healthBarHit: [
    "/assets/healthBar/2.svg",
    "/assets/healthBar/3.svg",
    "/assets/healthBar/4.svg",
    "/assets/healthBar/5.svg",
  ],
  sonicImage: "/assets/images/sonic.svg",
  completedIcon: "/assets/logos/completed.svg",
  heroBannerBG: (index) => `/assets/heroBannerBG/banner ${index}.svg`, 
  heroBanner: (index) => `/assets/heroBanner/hero banner ${index}.svg`,
  logos: (index) => `/assets/logos/${index}.png`, 
  trustedCorp: (index) => `/assets/trustedCorp/${index}.svg`,
  buttons: {
    upArrow: "/assets/buttons/upArrow.svg",
    orangeGradient: "/assets/buttons/orangeGradientBG.svg",
    blueGradient: "/assets/buttons/blueGradient.svg",
    dropDown: "/assets/buttons/dropDownButton.svg",
  },
  featureCards: {
    card1: "/assets/featureCards/1.svg",
    card2: "/assets/featureCards/2.svg",
    card3: "/assets/featureCards/3.svg",
    card4: "/assets/featureCards/4.svg",
    star: "/assets/featureCards/Star 1.svg",
    whiteBoard: "/assets/featureCards/whiteBoard.svg",
  },
  introduction: {
    intro: "/assets/introduction/intro.svg",
    started: "/assets/introduction/getting-started.svg",
  },
  extensionImage: {
    extension: "/assets/extensionImage/extension.png",
    neutralFace: "/assets/extensionImage/Neutral-face.png",
    getExtension: "/assets/extensionImage/getExtension.svg",
    ringLeft: "/assets/rings/ring-left.svg",
  },
  misc: {
    chips: "/assets/images/chips.png",
    footerLogo: "/assets/logos/footerLogo.svg",
    footerSocial1: "/assets/logos/footerSocial1.svg",
    footerSocial2: "/assets/logos/footerSocial2.svg",
    footerSocial3: "/assets/logos/footerSocial3.svg",
    footerSocial4: "/assets/logos/footerSocial4.svg",
    footerSocial5: "/assets/logos/footerSocial5.svg",
  },
  pricing_logos:{
    popular: "/assets/all_caps/popularCaptcha.svg",
    bls: "/assets/all_caps/bls-captcha.png",
    recaptcha: "/assets/all_caps/recaptcha-v2.png",
    aws: "/assets/all_caps/aws-waf.png",
    geetest:  "/assets/all_caps/geetest.png",
    imagetotext: "/assets/all_caps/imgtotxt.png",
    mtcaptcha: "/assets/all_caps/mt-captcha.png",
    prosopo:"/assets/all_caps/prosopo.png",
    tiktok: "/assets/all_caps/tiktok-captcha.png",
    captchafox: "/assets/all_caps/CaptchaFox.png",
    cloudflare: "/assets/all_caps/cloudflare-challenge.png",
  },
  contact_icons:{
    github: "/assets/icons/github.svg",
    telegram: "/assets/icons/telegram.svg",
    discord: "/assets/icons/discord.svg"
  },
  footer:"/assets/logos/footerLogo.svg",
  chrome:"/assets/icons/chrome.svg",
  firefox: "/assets/icons/firefox.png" ,
  zip: "/assets/icons/zip.png",
};
